import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { ElevatedBox, Card, InfoIconCaption } from 'components/layout'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'
import { apiDownloadFile } from 'helpers/decorators/api'
import styles from './badge-log-card.styl'
import { NewBadgeModal } from '../../../modals'
import { getBadgeIconImg } from '../../../../helpers/badgeHelper'
import { FormattedDate } from '../../../intl'
import { FormattedMessage } from 'react-intl'

@apiDownloadFile({ withCode: true })
class BadgeLogCard extends Component {
  static propTypes = {
    onOpenDetail: PropTypes.func,
    activitySection: PropTypes.string,
    log: PropTypes.object,
    variableHeight: PropTypes.bool,
    award: PropTypes.object.required,
    activity: PropTypes.object.required,
    modal: PropTypes.func,
    id: PropTypes.string
  }

  state = {
    badgeData: null
  }

  handleViewBadge = badgeData => {
    this.setState({ badgeData })
    this.props.modal(`view-badge-detail-modal-${this.props.id}`)
  }

  render() {
    const {
      log,
      activitySection,
      variableHeight,
      onOpenDetail,
      award,
      activity,
      id
    } = this.props

    const badge = get(log, 'badge')
    const badgeIconImg = getBadgeIconImg(award, get(log, 'badge'), true)
    const colorClass = getActivityClassName(activitySection)
    const classNames = [styles.item, styles[colorClass]]
    const badgeData = { data: {
        badge,
        award,
        activity,
        badges: []
      } }

    const modalId = `view-badge-detail-modal-${id}`

    return (
      <div className={classNames.join(' ')}>
        <ElevatedBox
          onClick={() => { this.handleViewBadge(badgeData) }}
          clickable={Boolean(onOpenDetail)}
        >
          <Card.Wrap variableHeight={variableHeight}>
            <Card.Left>
              <div className={styles.badgeIcon}>
                <div className={styles.badgeIcon}>
                  <img className={styles.badgeImg} src={`data:image/png;base64, ${badgeIconImg}`} />
                </div>
              </div>
            </Card.Left>
            <Card.Content>
              <div style={{ marginLeft: '10px' }}>
                <Card.Top>
                  <Card.Middle>
                    <h3 className={styles.description}>
                      {get(badge, 'name.translationText')}:
                      {' '} <FormattedMessage id='label.level' defaultMessage='Level' />
                      {' ' + get(badge, 'badgeLevel.translationText')}
                    </h3>
                  </Card.Middle>
                </Card.Top>
                <Card.Bottom>
                  <p className={styles.text}>
                    {get(log, 'date') && (
                      <InfoIconCaption
                        ico="date"
                        caption={
                          <FormattedDate
                            value={log.date}
                            year="numeric"
                            month="numeric"
                            day="numeric"
                          />
                        }
                        colorClass={colorClass}
                      />
                    )}
                  </p>
                </Card.Bottom>
              </div>
            </Card.Content>
          </Card.Wrap>
        </ElevatedBox>
        <NewBadgeModal data={this.state.badgeData} modalId={modalId} />
      </div>
    )
  }
}

export default BadgeLogCard
